import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-angle-left-filled",
  "use": "rt-base-angle-left-filled-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-angle-left-filled\"><path d=\"M696 265.1V759c0 14.1-16.9 22.1-28.6 13.5L336.6 528.8c-11.5-8.4-11.5-25.1 0-33.5l330.8-243.7c11.7-8.7 28.6-0.6 28.6 13.5z\" p-id=\"2890\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/angle-left-filled.svg
// module id = 1663
// module chunks = 137